<template>
    <div>
        <h3>2.未认证玩家配置</h3>
        <div class="border-card">
            <h4>规则说明：</h4>
            <div class="now-config">
                <el-form-item  v-if="is_configured" class="form-inline" prop="no_identified_user_rule.timing_period_days">
                    <el-input-number
                        class="w70"
                        size="mini"
                        :min="1"
                        :controls="false"
                        :precision="0"
                        v-model="params.no_identified_user_rule.timing_period_days"
                        disabled=true
                    ></el-input-number>
                </el-form-item>
                <span v-else>{{params.no_identified_user_rule.timing_period_days}}</span>
                天内 累计登陆
                <el-form-item  v-if="is_configured" class="form-inline" prop="no_identified_user_rule.total_game_minutes">
                    <el-input-number
                        class="w70"
                        size="mini"
                        :min="0"
                        :precision="0"
                        :controls="false"
                        v-model="params.no_identified_user_rule.total_game_minutes"
                        disabled=true
                    ></el-input-number>
                </el-form-item>
                <span v-else>{{params.no_identified_user_rule.total_game_minutes}}</span>
                min，要求玩家实名认证。
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "noIdentified",
    props: {
        params: {
            type: Object,
            default: () => {}
        },
        is_configured: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// website/subComponents/antiAddiction/noIdentified.vue